// Redux action types
export const SET = 'one-state-notes-history/set';
export const ADD = 'one-state-notes-history/add';
export const DISABLE_ADD = 'one-state-notes-history/disableAdd';
export const SET_STATUS = 'one-state-notes-history/setStatus';
export const REINIT = 'one-state-notes-history/reinit';
